const SIZE_XSMALL = 'xsmall';
const SIZE_SMALL = 'small';
const SIZE_LARGE = 'large';
const SIZE_MEDIUM = 'medium';

const OPTION_KEY_LABEL= 'label';
const OPTION_KEY_VALUE = 'value';
const OPTION_KEY_IS_DISABLED = 'isDisabled';
const OPTION_KEY_IS_GROUP = 'isGroup';
const OPTION_KEY_IS_SELECTED = 'isSelected';

const  constants = Object.freeze({
  COMPONENT_NAME: 'CCFormDropdown',

  SIZE_XSMALL: SIZE_XSMALL,
  SIZE_SMALL: SIZE_SMALL,
  SIZE_MEDIUM: SIZE_MEDIUM,
  SIZE_LARGE: SIZE_LARGE,
  SIZES: [SIZE_XSMALL, SIZE_SMALL, SIZE_MEDIUM, SIZE_LARGE],
  SIZE_DEFAULT: SIZE_MEDIUM,

  OPTION_KEY_LABEL: OPTION_KEY_LABEL,
  OPTION_KEY_VALUE: OPTION_KEY_VALUE,
  OPTION_KEY_IS_DISABLED: OPTION_KEY_IS_DISABLED,
  OPTION_KEY_IS_GROUP: OPTION_KEY_IS_GROUP,
  OPTION_KEY_IS_SELECTED: OPTION_KEY_IS_SELECTED,

  CLASSNAME_BASE: 'relative rounded-lg',
  CLASSNAME_IS_INLINE: {
    true: 'inline-block',
    false: 'block'
  },
  CLASSNAME_SIZE: Object.fromEntries(
    new Map([
      [SIZE_XSMALL, 'text-cc-body-small'],
      [SIZE_SMALL, 'text-cc-body-medium'],
      [SIZE_MEDIUM, 'text-cc-body-medium'],
      [SIZE_LARGE, 'text-cc-body-large']
    ])
  ),

});

export default constants;
